export type SensorSerialNumber = string;

export const isSensorSerialNumber = (
  value: unknown
): value is SensorSerialNumber => {
  return (
    typeof value === "string" && value.length >= 8 && !isNaN(parseInt(value))
  );
};
